import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from "@contentful/rich-text-types";
import './ContactPage.scss';
import { easeOut, motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

// Displays contact information from Contentful with rich text formatting
const ContactPage = ({ contact }) => {
    // Configuration for rich text rendering
    const renderOptions = {
        // Handle line breaks in text
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        // Handle hyperlinks in rich text
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };

    // Return early if contact information is not available
    if (!contact || !contact[0]?.contactInfo) {
        return <div>No contact information available</div>;
    }

    return (
        <>
            <Helmet>
                <title>contact - nthng</title>
                <meta name="description" content="Get in touch with nthng" />
                <link rel="canonical" href="https://nthng.nl/contact" />
                <meta property="og:title" content="Contact - nthng" />
                <meta property="og:description" content="Contact - nthng" />
                <meta property="og:url" content="https://nthng.nl/contact" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://nthng.nl/content/nthng_unfinished.webp" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Contact - nthng" />
                <meta name="twitter:description" content="Contact - nthng" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "ContactPage",
                        "name": "Contact nthng",
                        "description": "Contact nthng for booking inquiries, press requests, and collaborations",
                        "url": "https://nthng.nl/contact",
                        "mainEntity": {
                            "@type": "MusicGroup",
                            "name": "nthng",
                            "url": "https://nthng.nl"
                        }
                    })}
                </script>
            </Helmet>
            <motion.div
                className="contact-info"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                    duration: 0.25, ease: easeOut
                }}
            >
                {/* Render contact information with rich text formatting */}

                {documentToReactComponents(contact[0].contactInfo, renderOptions)}

            </motion.div>
            {/* Website credit footer */}

            <motion.div
                className="website-credit"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                    duration: 0.25, ease: easeOut
                }}
            >web development <a href="https://ff87c3.eu" target="_blank">ff87c3.eu</a></motion.div>
        </>
    )
}

export default ContactPage